import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import { connect } from 'react-redux';
import * as actions from '../../actions/BlogActions'
import { fetchAPIDeleteProduct } from '../../actions/ProductActions';

class ModalAlert extends Component {

    closeModal = () => {
        this.props.hideModal();
    }

    handleDeleteBlog = (id) => {
        this.props.deleteBlog(id)
        this.closeModal();
    }

    handleDeleteProduct = (id) => {
        this.props.deleteProduct(id)
        this.closeModal();
        window.location.href= "/products"
    }

    render() {
        var { blog, product } = this.props;
        if (blog) {
            return (
                <>
                    <Modal.Header>
                        <Modal.Title>
                            Delete Blog
                            </Modal.Title>
                        <button
                            type="button"
                            className="close-header"
                            onClick={this.closeModal}
                        >
                            <i className="fa fa-times mr-3"></i>
                        </button>
                    </Modal.Header>
                    <Modal.Body>
                        <h3 style={{ fontSize: '20px' }} className="mt-3 mb-4">
                            Bạn có chắc chắn muốn xoá ?
                            </h3>
                        <button
                            className="btn btn-primary btn-lg btn-rb mr-3"
                            onClick={() => this.handleDeleteBlog(blog.id)}
                        >Xoá blog</button>

                        <button
                            className="btn btn-outline-secondary btn-lg"
                            onClick={this.closeModal}
                        >Huỷ</button>
                    </Modal.Body>
                </>
            );
        } else if (product) {
            return (
                <>
                    <Modal.Header>
                        <Modal.Title>
                            Delete Product
                            </Modal.Title>
                        <button
                            type="button"
                            className="close-header"
                            onClick={this.closeModal}
                        >
                            <i className="fa fa-times mr-3"></i>
                        </button>
                    </Modal.Header>
                    <Modal.Body>
                        <h3 style={{ fontSize: '20px' }} className="mt-3 mb-4">
                            Bạn có chắc chắn muốn xoá ?
                            </h3>
                        <button
                            className="btn btn-primary btn-lg btn-rb mr-3"
                            onClick={() => this.handleDeleteProduct(product.id)}
                        >Xoá product</button>

                        <button
                            className="btn btn-outline-secondary btn-lg"
                            onClick={this.closeModal}
                        >Huỷ</button>
                    </Modal.Body>
                </>
            );
        }
    }
}

const mapStateToProps = (state) => {
    return {
        ...state.modal
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        deleteBlog: (id) => {
            dispatch(actions.fetchAPIDeleteBlog(id))
        },
        deleteProduct: (id) => {
            dispatch(fetchAPIDeleteProduct(id))
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ModalAlert);